import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    contact: "",
    query: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          fullname: formData.fullname,
          email: formData.email,
          contact: formData.contact,
          query: formData.query,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Your message has been sent!",
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            background: "#f3e6e2",
            color: "#333",
            iconColor: "#28a745",
          });

          setFormData({ fullname: "", email: "", contact: "", query: "" });
        },
        () => {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Oops! Something went wrong.",
            text: "Please try again later.",
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            background: "#f8d7da",
            color: "#721c24",
            iconColor: "#dc3545",
          });
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6 pt-16"
      style={{
        background: "linear-gradient(to right, #f3e6e2, #e8dfdb)",
      }}
    >
      <div className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-2xl">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-4">
          Transforming Your Business with Global Workforce Solution
        </h2>
        <form className="grid grid-cols-1 gap-4" onSubmit={handleSubmit}>
          <div>
            <label className="block text-gray-700">Full Name*</label>
            <input
              type="text"
              name="fullname"
              value={formData.fullname}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              placeholder="Your Name"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700">Email*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              placeholder="Your Email"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700">Contact*</label>
            <input
              type="tel"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              placeholder="Your Contact Number"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700">Query*</label>
            <textarea
              name="query"
              value={formData.query}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
              placeholder="Your Query"
              rows="4"
              required
            ></textarea>
          </div>
          <div>
            <button
              type="submit"
              className="w-full bg-gray-800 text-white p-3 rounded-lg hover:bg-gray-900 transition"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
